<div class="wrapper" *ngIf="shouldRenderLayout">
  <app-sidebar></app-sidebar>

  <div class="main">
    <app-header></app-header>
    <div class="content router-container" [ngClass]="{'white-background': !isHomePage}">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<div class="full-page-container" *ngIf="!shouldRenderLayout">
  <router-outlet></router-outlet>
</div>
